// extracted by mini-css-extract-plugin
export default {"action":"shortlist_for_profile_button-module___action___f2274fbe","tip":"shortlist_for_profile_button-module___tip___abeb5c93"};